import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useParams } from 'react-router';
import { ROUTES } from 'constants/routes';
import { AppointmentsSection } from './components/AppointmentsSection';
import { AppointmentsSectionMode } from './components/AppointmentsSection/types';
import { PatientInfo } from './components/PatientInfo';
import { TestsSection } from './components/TestsSection';
import { useFetchPatientAppointments } from './useFetchPatientAppointments';

export const PatientProfile = (): React.ReactElement => {
  const params = useParams();
  const patientId = params?.id;
  const {
    data: appointments,
    isLoading: isLoadingAppointments,
    isFetching,
  } = useFetchPatientAppointments(patientId ?? '');
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.PSYCHOLOGIST);
  const isLoading = isLoadingAppointments || isFetching;

  if (!patientId) {
    return <Navigate to={ROUTES.PSYCHOLOGIST_PATIENTS} />;
  }

  return (
    <div className="flex flex-col gap-8">
      <h1 className="text-3xl font-semibold max-am-lg:hidden">
        {t('PsychologistPatients.PatientProfile.heading')}
      </h1>
      <Button
        variant="terciary"
        icon="leading"
        className="w-fit flex items-center gap-2"
        onClick={() => navigate(ROUTES.PSYCHOLOGIST_PATIENTS)}
      >
        <ArrowLeft className="w-4 h-4" />
        {t('Common.back', { ns: LOCIZE_NS.COMMON })}
      </Button>
      <PatientInfo patientId={patientId} />
      <AppointmentsSection
        appointments={appointments?.future ?? []}
        isLoading={isLoading}
        title={t('PsychologistPatients.PatientProfile.futureAppointments.heading')}
        emptyMessage={t('PsychologistPatients.PatientProfile.futureAppointments.empty')}
        mode={AppointmentsSectionMode.future}
      />
      <AppointmentsSection
        appointments={appointments?.past ?? []}
        isLoading={isLoading}
        title={t('PsychologistPatients.PatientProfile.pastAppointments.heading')}
        emptyMessage={t('PsychologistPatients.PatientProfile.pastAppointments.empty')}
      />
      <TestsSection />
    </div>
  );
};
